// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export function buildSearchParams(params: Record<string, unknown>) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        searchParams.append(key, String(item));
      }
    } else {
      searchParams.set(key, String(value));
    }
  });

  return searchParams;
}

export function toFormData(params: Record<string, unknown>) {
  const formData = new FormData();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    const items = Array.isArray(value) ? value : [value];

    for (const item of items) {
      const val =
        item instanceof File || (item && typeof item === 'object')
          ? (item as Blob)
          : String(item);
      formData.append(key, val);
    }
  });

  return formData;
}
